import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { ZeroState } from 'ecs-react-components/dist/index.es';

import { loadTreatmentSummaryItems,
  unseenCountTreatmentSummaryItems } from '../../redux/modules/treatment-summary/treatment-summary-middleware';
import { messages } from './TreatmentSummary.i18n';
import { auditRequest } from '../../redux/modules/audit/audit-middleware';
import { TreatmentSummaryItemGroup } from '../../components/TreatmentSummary/treatmentSummaryItemGroup';
import Header from '../../components/Header/Header';
import LoadingIndicatorContainer from '../LoadingIndicatorContainer';
import { callWithLoadingIndicator } from '../../redux/modules/loading-indicator/loading-indicator-middleware';

const TREAMENT_SUMMARY_VIEW_AUDIT_TYPE = 'treatmentsummaryviewauditevent';

class TreatmentSummary extends Component {
  componentDidMount() {
    if (this.props.patient.patientId) {
      this.props.dispatch(auditRequest(TREAMENT_SUMMARY_VIEW_AUDIT_TYPE, this.props.patient.patientId));
      this.props.dispatch(
        callWithLoadingIndicator(
          'TreatmentSummary',
          () => this.props.dispatch(loadTreatmentSummaryItems(this.props.patient.patientId))
        )
      );
    }
  }

  componentWillUnmount() {
    const { dispatch, patient } = this.props;
    dispatch(unseenCountTreatmentSummaryItems(patient.patientId));
  }

  render() {
    const summaryItemsPresent = this.props.treatmentSummaryItems && this.props.treatmentSummaryItems.length > 0;
    this.firstCategory = true;
    return (
      <div id="treatment-summary-content">
        <div className="col">
          <Header headerClassName="mb-3" headerTitle={<FormattedMessage { ...messages.page.title } /> }
            badgeNumber={this.props.unseenTreatmentSummaryItems}
          />
          <LoadingIndicatorContainer loadingKey="TreatmentSummary">
            {
              !summaryItemsPresent ?
                <ZeroState
                  zeroStateMessage={ <FormattedMessage { ...messages.page.noTreatmentSummaryItems } /> }
                  stateIconCss="fa-solid fa-suitcase-medical"
                /> :
                <div className="row mb-3">
                  {
                    this.props.treatmentSummaryItems.map((group) =>
                      (<TreatmentSummaryItemGroup key={group.key} groupKey={group.key}
                        items={group.value} language={this.props.language}
                        capabilities={
                          this.props.capabilities.details.find((x) => x.fieldName === 'TreatmentTypes').details
                            .find((y) => y.fieldName === group.key)
                        }
                      />)
                    )
                  }
                </div>
            }
          </LoadingIndicatorContainer>
        </div>
      </div>
    );
  }
}

TreatmentSummary.propTypes = {
  dispatch: PropTypes.func.isRequired,
  intl: PropTypes.object,
  treatmentSummaryItems: PropTypes.array,
  time: PropTypes.string,
  unseenTreatmentSummaryItems: PropTypes.number,
  language: PropTypes.string,
  patient: PropTypes.object,
  capabilities: PropTypes.object,
};

const mapStateToProps = (state) => ({
  treatmentSummaryItems: state.treatmentSummary.treatmentSummaryItems,
  time: state.treatmentSummary.currentTime,
  unseenTreatmentSummaryItems: state.treatmentSummary.unseenTreatmentSummaryItems,
  language: state.language.languageCode,
  patient: state.profile.patient,
  capabilities: state.capability.capabilities.find((x) => x.moduleName === 'TreatmentSummary'),
});

export default connect(mapStateToProps)(injectIntl(TreatmentSummary));